import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { RutFormat, formatRut } from '@fdograph/rut-utilities';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TOAST_CONFIG, ToastrService } from 'ngx-toastr';
import { Clients } from 'src/app/models/interfaces/clients';
import { ApiService } from 'src/app/services/api.service';
import { ApiEntryControlService } from '../../api-entry-control.service';
import { Facility } from '../../interfaces/facility';
import { Helps } from 'src/app/libs/helps';

@Component({
  selector: 'app-edit-store',
  templateUrl: 'edit-store.component.html',
  styleUrls: ['./edit-store.component.css']
})
export class EditStoreComponent implements OnInit, OnChanges {
  constructor(
    private api: ApiEntryControlService,
    private toast: ToastrService,
    private modal: NgbModal,
    private router: Router,
    private routeActive: ActivatedRoute,
    private helps: Helps
  ) { }
  level: number = 0;
  ngOnChanges(changes: SimpleChanges): void {
    console.log("LLEGO A BODEGA");
    var data = this.routeActive.snapshot.params;
    this.dataId = data['id'];
    this.level
    if (this.dataId > 0) {
      this.dataId;
      this.getClient(this.dataId);
    } else if ((data['id'] != null)) {
      this.getClient(data['id']);
    } else {
      this.router.navigate(['/control-ingreso/dependencias/gestion']);
    }
  }
  ngOnInit(): void {
    this.level = this.helps.getToken()?.level;
    console.log("LLEGO A BODEGA");
    var data = this.routeActive.snapshot.params;
    this.getFacility();
    this.dataId = data['id'];
    if (this.dataId > 0) {
      this.dataId;
      this.getClient(this.dataId);
    } else if ((data['id'] != null)) {
      this.getClient(data['id']);
    } else {
      this.router.navigate(['/control-ingreso/dependencias/gestion']);
    }
  }

  @Input()
  template: string;
  @Input()
  dataId: number = 0;

  @Input()
  modalRef: NgbModalRef | undefined;

  @Output()
  success = new EventEmitter<boolean>();
  @Output()
  record = new EventEmitter<Clients>();
  id: number = 0;
  active = 1;
  items: any;
  view: number = 1;
  form = new UntypedFormGroup({
    id: new UntypedFormControl(),
    name: new UntypedFormControl(),
    lastname: new UntypedFormControl(),
    owner: new UntypedFormControl(''),
    owner_phone: new UntypedFormControl(''),
    rut: new UntypedFormControl(''),
    turn: new UntypedFormControl(''),
    location: new UntypedFormControl(''),
    img_path: new UntypedFormControl(''),
    facility_id: new UntypedFormControl(0),
    email: new UntypedFormControl(''),
    phone: new UntypedFormControl(''),
    hide_rounds: new UntypedFormControl(false),
  });
  facilitys: Facility[];
  getClient(id: number) {
    this.api.getStore(id).subscribe(
      (response) => {
        this.form.patchValue(response.data);
        if (this.level < 99) {
          this.form?.disable();
        }
      },
      (error) => {
        this.toast.warning('', 'Dependencia no encontrada');
        this.router.navigate(['/control-ingreso/dependencias/gestion']);
      }
    );
  }
  getFacility() {
    this.api.getAllFacility().subscribe((res) => {
      this.facilitys = res.data as Facility[];
    });
  }
  update() {
    if (this.level < 99) {
      this.toast.warning("No tiene los privilegios para editar esta sección");
      return;
    }
    this.api.updateStore(this.form).subscribe(
      (response) => {
        this.toast.success(
          response.msg,
          'Gestión Recinto'
        );
        this.record.emit(response.data as Clients);
        this.success.emit(true);
        if (this.modalRef != null) {
          this.modalRef.close();
        } else {
          this.modal.dismissAll();
        }
      },
      (error) => {
        this.toast.warning(error.error.mistakes, 'Tenemos un error', {
          enableHtml: true,
          closeButton: true
        });
      }
    );
  }
  onFormatRut(value: any) {
    let rut = value.target.value;
    if (rut.length > 8) {
      rut = formatRut(rut, RutFormat.DOTS_DASH)
      this.form
        .get('rut')
        ?.setValue(rut);
    }
  }
  openModal(md: any, size = 'md') {
    this.modalRef = this.modal.open(md, {
      size: size,
    });
  }
  hideRounds(event: any) {
    let checked: boolean = event?.target.checked;
    let value = (checked) ? 1 : 0;
    this.form.get('hide_rounds')?.setValue(value);
    console.log("checked:",checked);
    console.log("value:",value);
  }
}
